export enum DayOfMonthType {
    FirstDay = 1,
    LastDay = 2,
    Custom = 3,
}